import { render, staticRenderFns } from "./EditStock.vue?vue&type=template&id=4c6a274f&"
import script from "./EditStock.vue?vue&type=script&lang=js&"
export * from "./EditStock.vue?vue&type=script&lang=js&"
import style0 from "./EditStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports